<template>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button
        class="button_back"
        data-testid="directions-38"
        @click="goBack"
      >
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Create Job Ad</ion-title>
    <ion-buttons slot="end">
      <ion-button
        data-testid="directions-39"
        @click="goNext()"
        :disabled="isSubmitDisabled"
        class="pill next-pill-button"
      >
        <span>Next</span>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <div class="main_wrapper ion-padding">
    <div class="container">
      <el-form
        class="full_page"
        :model="form"
        ref="userForm"
        label-position="top"
      >
        <div class="describe-need">
          <el-form-item
            :required="true"
            label="Do you have any questions that you want to ask the applicants?"
          >
            <el-radio-group v-model="form.questionary">
              <el-radio label="Yes" size="large">Yes</el-radio>
              <el-radio label="No" size="large">No</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- Conditional rendering of question input section -->
          <div v-if="form.questionary === 'Yes'">
            <div class="required-label text-center">Questions</div>
            <el-form-item-error v-if="v$.questions.$error">{{
              v$.questions.$errors[0].$validator === "required"
                ? v$.questions.$errors[0].$message
                : ""
            }}</el-form-item-error>
            <div
              v-for="(item, index) in form.questions"
              :key="index"
              class="question-row"
            >
              <el-form-item class="question-label" :error="v$.questions.$error && item.type == ''" :show-message="false">
                <el-select
                  popper-class="normal-select"
                  v-model="item.type"
                  placeholder="Select question type"
                  class="question-type-select"
                >
                  <el-option label="Paragraph" value="text">
                    <i class="el-icon-edit"></i>Paragraph</el-option
                  >
                  <el-option label="Checkboxes" value="checkbox"
                    ><i class="el-icon-check"></i>Checkboxes</el-option
                  >
                  <el-option label="Multiple choice" value="radio"
                    ><i class="el-icon-circle-check"></i>Multiple
                    choice</el-option
                  >
                  <el-option label="Dropdown" value="select"
                    ><i class="el-icon-arrow-down"></i>Dropdown</el-option
                  >
                  <el-option label="File upload" value="file"
                    ><i class="el-icon-upload"></i>File upload</el-option
                  >
                </el-select>
                <el-form-item-error v-if="v$.questions.$each.$message[index].length > 0 && item.type == ''">{{
                  v$.questions.$errors[0].$message[index][0]
                }}</el-form-item-error>
                <div class="question-footer">
                      <el-button
                        type="danger"
                        class="remove-question"
                        @click="removeQuestion(index)"
                      >
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M15.8025 3.9225C14.595 3.8025 13.3875 3.7125 12.1725 3.645V3.6375L12.0075 2.6625C11.895 1.9725 11.73 0.9375 9.975 0.9375H8.01C6.2625 0.9375 6.0975 1.9275 5.9775 2.655L5.82 3.615C5.1225 3.66 4.425 3.705 3.7275 3.7725L2.1975 3.9225C1.8825 3.9525 1.6575 4.23 1.6875 4.5375C1.7175 4.845 1.9875 5.07 2.3025 5.04L3.8325 4.89C7.7625 4.5 11.7225 4.65 15.6975 5.0475C15.72 5.0475 15.735 5.0475 15.7575 5.0475C16.0425 5.0475 16.29 4.83 16.32 4.5375C16.3425 4.23 16.1175 3.9525 15.8025 3.9225Z"
                            fill="rgb(var(--locumate-clr-danger))"
                          />
                          <path
                            d="M14.4225 6.105C14.2425 5.9175 13.995 5.8125 13.74 5.8125H4.26C4.005 5.8125 3.75 5.9175 3.5775 6.105C3.405 6.2925 3.3075 6.5475 3.3225 6.81L3.7875 14.505C3.87 15.645 3.975 17.07 6.5925 17.07H11.4075C14.025 17.07 14.13 15.6525 14.2125 14.505L14.6775 6.8175C14.6925 6.5475 14.595 6.2925 14.4225 6.105ZM10.245 13.3125H7.7475C7.44 13.3125 7.185 13.0575 7.185 12.75C7.185 12.4425 7.44 12.1875 7.7475 12.1875H10.245C10.5525 12.1875 10.8075 12.4425 10.8075 12.75C10.8075 13.0575 10.5525 13.3125 10.245 13.3125ZM10.875 10.3125H7.125C6.8175 10.3125 6.5625 10.0575 6.5625 9.75C6.5625 9.4425 6.8175 9.1875 7.125 9.1875H10.875C11.1825 9.1875 11.4375 9.4425 11.4375 9.75C11.4375 10.0575 11.1825 10.3125 10.875 10.3125Z"
                            fill="rgb(var(--locumate-clr-danger))"
                          />
                        </svg>
                      </el-button>
                    </div>
                <div v-if="item.type === 'text'">
                  <div class="question-header">
                    Question {{ index + 1 }}
                    
                  </div>
                  <el-form-item class="question-label" :error="v$.questions.$each.$message[index].length > 0 && item.type == 'text'" :show-message="false">
                  <el-input
                    type="textarea"
                    v-model="item.question"
                    @input="handleQuestionChange(index, $event.target.value)"
                    :placeholder="`Question ${index + 1}`"
                    :maxlength="225"
                    show-word-limit
                  ></el-input>
                </el-form-item>
                  <el-form-item-error v-if="v$.questions.$each.$message[index].length > 0 && item.type == 'text'">{{
                    v$.questions.$errors[0].$message[index][0]
                  }}</el-form-item-error>
                </div>

                <div
                  v-if="
                    item.type === 'checkbox' ||
                    item.type === 'radio' ||
                    item.type === 'select'
                  "
                >
                  <div class="question-header">
                    Question {{ index + 1 }}
                    <!-- <div class="question-footer">
                      <el-button
                        type="danger"
                        class="remove-question"
                        @click="removeQuestion(index)"
                      >
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M15.8025 3.9225C14.595 3.8025 13.3875 3.7125 12.1725 3.645V3.6375L12.0075 2.6625C11.895 1.9725 11.73 0.9375 9.975 0.9375H8.01C6.2625 0.9375 6.0975 1.9275 5.9775 2.655L5.82 3.615C5.1225 3.66 4.425 3.705 3.7275 3.7725L2.1975 3.9225C1.8825 3.9525 1.6575 4.23 1.6875 4.5375C1.7175 4.845 1.9875 5.07 2.3025 5.04L3.8325 4.89C7.7625 4.5 11.7225 4.65 15.6975 5.0475C15.72 5.0475 15.735 5.0475 15.7575 5.0475C16.0425 5.0475 16.29 4.83 16.32 4.5375C16.3425 4.23 16.1175 3.9525 15.8025 3.9225Z"
                            fill="rgb(var(--locumate-clr-danger))"
                          />
                          <path
                            d="M14.4225 6.105C14.2425 5.9175 13.995 5.8125 13.74 5.8125H4.26C4.005 5.8125 3.75 5.9175 3.5775 6.105C3.405 6.2925 3.3075 6.5475 3.3225 6.81L3.7875 14.505C3.87 15.645 3.975 17.07 6.5925 17.07H11.4075C14.025 17.07 14.13 15.6525 14.2125 14.505L14.6775 6.8175C14.6925 6.5475 14.595 6.2925 14.4225 6.105ZM10.245 13.3125H7.7475C7.44 13.3125 7.185 13.0575 7.185 12.75C7.185 12.4425 7.44 12.1875 7.7475 12.1875H10.245C10.5525 12.1875 10.8075 12.4425 10.8075 12.75C10.8075 13.0575 10.5525 13.3125 10.245 13.3125ZM10.875 10.3125H7.125C6.8175 10.3125 6.5625 10.0575 6.5625 9.75C6.5625 9.4425 6.8175 9.1875 7.125 9.1875H10.875C11.1825 9.1875 11.4375 9.4425 11.4375 9.75C11.4375 10.0575 11.1825 10.3125 10.875 10.3125Z"
                            fill="rgb(var(--locumate-clr-danger))"
                          />
                        </svg>
                      </el-button>
                    </div> -->
                  </div>
                  <el-form-item class="question-label" :error="v$.questions.$each.$message[index].length > 0 && (item.type === 'checkbox' ||
                    item.type === 'radio' ||
                    item.type === 'select') && item.options.length === 0" :show-message="false">
                  <el-input
                    type="textarea"
                    v-model="item.question"
                    @input="handleQuestionChange(index, $event.target.value)"
                    :placeholder="`Question ${index + 1}`"
                    :maxlength="225"
                    show-word-limit
                  ></el-input>
                </el-form-item>
                  <el-form-item-error v-if="v$.questions.$each.$message[index].length > 0 && (item.type === 'checkbox' ||
                    item.type === 'radio' ||
                    item.type === 'select') && item.options.length === 0">{{
                    v$.questions.$errors[0].$message[index][0]
                  }}</el-form-item-error>
                  <div
                    v-for="(option, optionIndex) in item.options"
                    :key="optionIndex"
                    class="question-option"
                  >
                  <el-form-item class="question-label" :error="item.options[optionIndex]==''" :show-message="false">
                    <el-input
                      type="textarea"
                      v-model="item.options[optionIndex]"
                      :placeholder="`Option ${optionIndex + 1}`"
                      :maxlength="225"
                      show-word-limit
                    ></el-input>
                  </el-form-item>
                    <el-form-item-error v-if="item.options[optionIndex]==''">{{
                    v$.questions.$errors[0].$message[index][0]
                  }}</el-form-item-error>
                    <el-button
                      type="danger"
                      icon="el-icon-close"
                      class="remove-option"
                      @click="removeOption(index, optionIndex)"
                    ></el-button>
                  </div>
                  <el-button
                    type="link"
                    class="add-option d-block ml-3"
                    size="small"
                    @click="addOption(index)"
                    ><i class="el-icon-plus"></i>Add Option</el-button
                  >
                </div>
                <div v-if="item.type === 'file'">
                  <div class="question-header">
                    Question {{ index + 1 }}
                    <div class="question-footer">
                      <!-- <el-button
                        type="danger"
                        class="remove-question"
                        @click="removeQuestion(index)"
                      >
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M15.8025 3.9225C14.595 3.8025 13.3875 3.7125 12.1725 3.645V3.6375L12.0075 2.6625C11.895 1.9725 11.73 0.9375 9.975 0.9375H8.01C6.2625 0.9375 6.0975 1.9275 5.9775 2.655L5.82 3.615C5.1225 3.66 4.425 3.705 3.7275 3.7725L2.1975 3.9225C1.8825 3.9525 1.6575 4.23 1.6875 4.5375C1.7175 4.845 1.9875 5.07 2.3025 5.04L3.8325 4.89C7.7625 4.5 11.7225 4.65 15.6975 5.0475C15.72 5.0475 15.735 5.0475 15.7575 5.0475C16.0425 5.0475 16.29 4.83 16.32 4.5375C16.3425 4.23 16.1175 3.9525 15.8025 3.9225Z"
                            fill="rgb(var(--locumate-clr-danger))"
                          />
                          <path
                            d="M14.4225 6.105C14.2425 5.9175 13.995 5.8125 13.74 5.8125H4.26C4.005 5.8125 3.75 5.9175 3.5775 6.105C3.405 6.2925 3.3075 6.5475 3.3225 6.81L3.7875 14.505C3.87 15.645 3.975 17.07 6.5925 17.07H11.4075C14.025 17.07 14.13 15.6525 14.2125 14.505L14.6775 6.8175C14.6925 6.5475 14.595 6.2925 14.4225 6.105ZM10.245 13.3125H7.7475C7.44 13.3125 7.185 13.0575 7.185 12.75C7.185 12.4425 7.44 12.1875 7.7475 12.1875H10.245C10.5525 12.1875 10.8075 12.4425 10.8075 12.75C10.8075 13.0575 10.5525 13.3125 10.245 13.3125ZM10.875 10.3125H7.125C6.8175 10.3125 6.5625 10.0575 6.5625 9.75C6.5625 9.4425 6.8175 9.1875 7.125 9.1875H10.875C11.1825 9.1875 11.4375 9.4425 11.4375 9.75C11.4375 10.0575 11.1825 10.3125 10.875 10.3125Z"
                            fill="rgb(var(--locumate-clr-danger))"
                          />
                        </svg>
                      </el-button> -->
                    </div>
                  </div>
                  <el-form-item class="question-label" :error="v$.questions.$each.$message[index].length > 0 && item.type == 'file'" :show-message="false">
                  <el-input
                    type="textarea"
                    v-model="item.question"
                    @input="handleQuestionChange(index, $event.target.value)"
                    :placeholder="`Question ${index + 1}`"
                    :maxlength="225"
                    show-word-limit
                  ></el-input>
                </el-form-item>
                  <el-form-item-error v-if="v$.questions.$each.$message[index].length > 0 && item.type == 'file'">{{
                    v$.questions.$errors[0].$message[index][0]
                  }}</el-form-item-error>
                </div>
              </el-form-item>
              
            </div>
            <el-button type="primary" class="add-question d-block" @click="addQuestion"
              ><i class="el-icon-plus"></i>Add Question</el-button
            >
          </div>
        </div>

      </el-form>
    </div>
    <el-drawer
      custom-class="bottom_drop_up"
      v-model="displaySubscription"
      :append-to-body="true"
      :with-header="false"
      :direction="'btt'"
      :destroy-on-close="true"
    >
      <Subscription />
    </el-drawer>
  </div>
</template>
<script>
import { reactive, computed, inject, onMounted, ref } from "vue";
import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";
import { IonToolbar, IonButton, IonButtons, IonIcon } from "@ionic/vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { useVuelidate } from "@vuelidate/core";
import { helpers, maxLength } from "@vuelidate/validators";
import Subscription from "../Subscription/Subscription.vue";

addIcons({ "arrow-back-outline": arrowBackOutline });

export default {
  components: { IonToolbar, IonButton, IonButtons, IonIcon, Subscription },
  setup() {
    const $router = useRouter();
    const $store = useStore();
    const setPageClassGlobal = inject(["setPageClassGlobal"]);
    const jobListingCreatePageData = $store.getters.getJobListingCreatePageData;
    const displaySubscription = ref(false);
    const form = reactive({
      questionary: jobListingCreatePageData.questionary || "Yes",
      questions:
        jobListingCreatePageData.questions.length !== 0
          ? jobListingCreatePageData.questions
          : jobListingCreatePageData.questionary === "Yes"
          ? [{ type: "", question: "", options: [] }]
          : [],
    });

    const addQuestion = () => {
      form.questions.push({ type: "", question: "", options: [] });
    };

    const removeQuestion = (index) => {
      form.questions.splice(index, 1);
    };

    const addOption = (questionIndex) => {
      form.questions[questionIndex].options.push("");
    };

    const removeOption = (questionIndex, optionIndex) => {
      form.questions[questionIndex].options.splice(optionIndex, 1);
    };

    const handleQuestionChange = (index, value) => {
      form.questions[index].question = value;
    };

    const handlePreview = (file) => {
      console.log("Preview:", file);
    };

    const handleRemove = (file, fileList) => {
      console.log("Remove:", file, fileList);
    };


    const rules = computed(() => {
  return {
    questions:
      form.questionary === "Yes"
        ? {
            required: helpers.withMessage(
              "At least one question is required",
              (value) => value.length > 0
            ),
            $each: helpers.forEach({
              type: {
                required: helpers.withMessage(
                  "Type must not be empty",
                  (value) => value.trim() !== ""
                ),
              },
              question: {
                required: helpers.withMessage(
                  "Question must not be empty",
                  (value) => value.trim() !== ""
                ),
                maxLength: helpers.withMessage(
                  "Question must not be greater than 255 character",
                  maxLength(255)
                ),
              },
              options: {
                required: helpers.withMessage(
                  "Options must not be empty for selected type",
                  (value, parentVm) => {
                    const type = parentVm.type;
                    if (["checkbox", "radio", "select"].includes(type)) {
                      return (
                        value &&
                        value.length > 0 &&
                        !value.some((option) => option.trim() === "")
                      );
                    }
                    return true;
                  }
                ),
                maxLength: helpers.withMessage(
                  "Option must not be greater than 255 character",
                  maxLength(255)
                ),
              },
            }),
          }
        : {},
  };
});
    const v$ = useVuelidate(rules, form);

    const goNext = async () => {
      const result = await v$.value.$validate();
      if (!result) {
        alert("The form has errors");
        return;
      }
      if (form.questionary === "No") {
        form.questions = [];
      }
      const plainFormData = {
        questionary: form.questionary,
        questions: form.questions.map((q) => ({
          type: q.type,
          question: q.question,
          options: [...q.options], // ensures plain array copy
        })),
      };
      $store.dispatch("setJobListingCreatePageData", plainFormData);
      displaySubscription.value = true;
    };

    const isSubmitDisabled = computed(() => {
      return (
        Object.values(form).some((value) => value === "") ||
        v$.value.$pending ||
        v$.value.$error ||
        v$.value.$invalid
      );
    });

    const goBack = () => {
      $router.push({ name: "job_description_listing" });
    };

    onMounted(() => {
      setPageClassGlobal("job_poster_create_job_question");
      if (form.questionary === "Yes" && form.questions.length === 0) {
        addQuestion();
        v$.value.$validate()
      }
    });

    return {
      goBack,
      goNext,
      form,
      v$,
      isSubmitDisabled,
      addQuestion,
      removeQuestion,
      handleQuestionChange,
      addOption,
      removeOption,
      handlePreview,
      handleRemove,
      displaySubscription,
    };
  },
};
</script>
